import { useState } from 'react';

export default function useView() {
  const [grid, setGrid] = useState(true);
  const [line, setLine] = useState(false);

  const changeGrid = () => {
    setGrid(true);
    setLine(false);
  };

  const changeLine = () => {
    setGrid(false);
    setLine(true);
  };

  return { grid, line, changeGrid, changeLine };
}
